import request from './request'

const api = {
  get(url, params = {}, config = {}) {
    return request({
      url,
      method: 'get',
      params,
      ...config
    })
  },

  post(url, data = {}, config = {}) {
    return request({
      url,
      method: 'post',
      data,
      ...config
    })
  },

  put(url, data = {}, config = {}) {
    return request({
      url,
      method: 'put',
      data,
      ...config
    })
  },

  delete(url, params = {}, config = {}) {
    return request({
      url,
      method: 'delete',
      params,
      ...config
    })
  }
}

export default api